import React from 'react';
import { StyleSheet, View, type ViewProps } from 'react-native';

import { theme } from '@garnish/constants';

import { BodyText } from '../../../Text';

// ─────────────────────────────────────────────────────────────────────────────

export const ScreenHeaderDisclaimer = (props: Props) => {
  const { children, style } = props;

  const containerStyles = [styles.container, style];

  return (
    <View style={containerStyles}>
      <BodyText sizeMatch={['16']} style={styles.text}>
        {children}
      </BodyText>
    </View>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    backgroundColor: theme.colors.CUCUMBER,
    paddingHorizontal: theme.spacing['4'],
    paddingVertical: theme.spacing['5'],
  },
  text: {
    color: theme.colors.DARK_KALE,
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = {
  children: React.ReactNode;
  style?: ViewProps['style'];
};
